module.exports = __webpack_public_path__ + "static/img/11.ad7b1c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/11.png
// module id = yEUc
// module chunks = 0